import DashboardIcon from "@mui/icons-material/Dashboard";
import EmojiFlagsIcon from "@mui/icons-material/EmojiFlags";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from '@mui/icons-material/Business';
import PlaceIcon from "@mui/icons-material/Place";
import QuizIcon from '@mui/icons-material/Quiz';
import AssessmentIcon from '@mui/icons-material/Assessment';
import GroupIcon from "@mui/icons-material/Group";
import LogoutIcon from "@mui/icons-material/Logout";
import AppsIcon from '@mui/icons-material/Apps';
import SchoolIcon from "@mui/icons-material/School";
import TopicIcon from "@mui/icons-material/Topic";
import BuildIcon from "@mui/icons-material/Build";
import GridOnIcon from "@mui/icons-material/GridOn";
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import Groups2Icon from '@mui/icons-material/Groups2';
import FolderSpecialIcon from "@mui/icons-material/FolderSpecial";
import WorkIcon from "@mui/icons-material/Work";
import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";
import LanguageIcon from '@mui/icons-material/LanguageOutlined';
import ShieldIcon from '@mui/icons-material/Shield';
import StarRateIcon from '@mui/icons-material/StarRate';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
  Typography,
} from "@mui/material";
import useApp from "hooks/useApp";
import { Feature } from "models/api";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SubMenuItem from "./SubMenuItem";
import { getUserData } from "helpers";
import { IPermission } from "models/permissions";
import { viewable } from "components/SideMenu";

interface Props {
  name: string;
  icon: string;
  feature: Feature;
  currPermissions: IPermission[] | null;
  selectedFeature?: Feature;
  hasChildren?: boolean;
  color: "black" | "white";
  slug?: string;
  action?: () => void;
  setOpenDrawer?: React.Dispatch<React.SetStateAction<boolean>>;
  onSelectUnLinkFeature?: (feature: any) => void;
  open?: boolean;
}

const MenuItem: React.FC<Props> = ({
  name,
  icon,
  currPermissions,
  color,
  selectedFeature,
  slug,
  feature,
  hasChildren,
  onSelectUnLinkFeature,
  setOpenDrawer,
  open,
}) => {
  const { currentRoute, push } = useApp();
  const isSelected = currentRoute === `/${slug!}`;
  const userData = getUserData();
  const { colors, roleName } = userData;

  const renderIcon = (icon: string): React.ReactNode => {
    if (icon === "CompanyIcon")
      return (
        <BusinessIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );

    if (icon === "RateIcon")
      return (
        <StarRateIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );

    if (icon === "QuestionIcon")
      return (
        <QuizIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );

    if (icon === "AssessmentIcon")
      return (
        <AssessmentIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );

    if (icon === "ProfIcon")
      return (
        <EmojiEventsIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );

    if (icon === "AppIcon")
      return (
        <AppsIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );

    if (icon === "DashboardIcon")
      return (
        <DashboardIcon
          sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }}
        />
      );

    if (icon === "LanguageIcon")
      return (
        <LanguageIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );

    if (icon === "GridIcon")
      return (
        <GridOnIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );
    if (icon === "SecurityIcon")
      return (
        <ShieldIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );


    if (icon === "DepartIcon")
      return (
        <FolderSpecialIcon
          sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }}
        />
      );
    if (icon === "JobsIcon")
      return (
        <WorkIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );
    if (icon === "RolesIcon")
      return (
        <PermContactCalendarIcon
          sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }}
        />
      );
    if (icon === "LogoutIcon")
      return (
        <LogoutIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );
    if (icon === "EmojiFlagsIcon")
      return (
        <EmojiFlagsIcon
          sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }}
        />
      );
    if (icon === "LocationCityIcon")
      return (
        <LocationCityIcon
          sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }}
        />
      );
    if (icon === "AccountBoxIcon")
      return (
        <AccountBoxIcon
          sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }}
        />
      );
    if (icon === "GroupIcon")
      return (
        <GroupIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );
    if (icon === "PlaceIcon")
      return (
        <PlaceIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );
    if (icon === "PersonIcon")
      return (
        <PersonIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );
    if (icon === "SchoolIcon")
      return (
        <SchoolIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );
    if (icon === "TopicIcon")
      return (
        <TopicIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );

    if (icon === "BuildIcon")
      return (
        <BuildIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );

    if (icon === "EmployeesIcon")
      return (
        <Groups2Icon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );



    return null;
  };

  const handleClick = () => {
    if (hasChildren) {
      selectedFeature?.slug === feature.slug
        ? onSelectUnLinkFeature!(null)
        : onSelectUnLinkFeature!(feature);

      return;
    } else onSelectUnLinkFeature!(null);

    push(`/${slug!}`);
    if (setOpenDrawer) setOpenDrawer(false);
  };

  const hasPermission = (feature: Feature) => {
    return (
      currPermissions?.find(
        (permission) => permission.rolePermissionId === feature.id
      )?.hasReadPermission && viewable(roleName, feature.roles)
    );
  };

  // Check if any child feature has permission
  const hasChildrenWithPermissions = feature.children.some((childFeature) =>
    hasPermission(childFeature)
  );

  // Don't render the entire accordion if no child has permissions
  if (hasChildren && !hasChildrenWithPermissions) {
    return null;
  }

  return (
    <Stack
      component={slug ? "a" : "button"}
      direction={"row"}
      alignItems={"unset"}
      bgcolor={
        isSelected
          ? colors?.menuItemSelectedColor
            ? colors?.menuItemSelectedColor
            : "sideMenu.selected"
          : "transparent"
      }
      px={3}
      border={"none"}
      borderRadius={1}
      onClick={handleClick}
      sx={{
        transition: "500ms",
        "&:hover": {
          bgcolor: colors?.menuItemHoverColor
            ? colors?.menuItemHoverColor
            : "#FFFFFF40",
        },
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
      }}
    >
      {hasChildren ? (
        <Accordion
          style={{
            backgroundColor: colors?.menuBgColor
              ? colors?.menuBgColor
              : "#000000",
            padding: 0,
            boxShadow: "none",
            color: "sideMenu.text",
          }}
        >
          <AccordionSummary
            sx={{
              padding: 0,
              margin: 0,
              "& .MuiAccordionSummary-content ": {
                marginInline: "0 !important",
              },
              "& .MuiAccordionSummary-content.Mui-expanded  ": {
                marginInline: "0 !important",
              },
              "& .MuiAccordionSummary-root.Mui-expanded  ": {
                marginLeft: "0px !important",
              },
              "&.MuiAccordionSummary-root.Mui-expanded .MuiTypography-root": {
                marginLeft: "16px !important",
              },
            }}
            expandIcon={<KeyboardArrowDownIcon sx={{ color }} />}
            aria-controls="panel2-content"
            id="panel2-header"
          >
            <div style={{ display: "flex", gap: "5px" }}>
              {renderIcon(icon)}
              {open && (
                <Typography
                  variant="body1"
                  fontWeight={500}
                  color="sideMenu.text"
                  sx={{
                    mx: 2,
                    minWidth: 200,
                    "&.MuiAccordionSummary-root.Mui-expanded .MuiTypography-root":
                    {
                      marginLeft: "0px !important",
                    },
                  }}
                >
                  {name}
                </Typography>
              )}
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              {feature.children.length > 0 &&
                feature.children.map((childFeature, index) => {
                  if (!hasPermission(childFeature)) return null;
                  return (
                    <SubMenuItem
                      key={index}
                      setOpenDrawer={setOpenDrawer}
                      icon={childFeature.icon}
                      name={childFeature.name}
                      slug={childFeature.slug}
                      color={color}
                    />
                  );
                })}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ) : (
        <Typography style={{ display: "flex", gap: "5px" }}>
          {renderIcon(icon)}
          {open && (
            <Typography
              variant="body1"
              fontWeight={500}
              color={"sideMenu.text"}
              sx={{
                mx: 2,
                minWidth: 200,
              }}
            >
              {name}
            </Typography>
          )}
        </Typography>
      )}
    </Stack>
  );
};

export default MenuItem;
